// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sale-card[data-v-4be2dbc4]{flex-shrink:0;display:block;overflow:hidden;border-radius:10px;cursor:pointer}.sale-card_m[data-v-4be2dbc4]{width:485px;height:274px}@media (max-width:800px){.sale-card_m[data-v-4be2dbc4]{width:300px;height:170px}}.sale-card_s[data-v-4be2dbc4]{width:235px;height:133px}@media (max-width:800px){.sale-card_s[data-v-4be2dbc4]{width:148px;height:84px}}.sale-card__img[data-v-4be2dbc4]{height:100%;object-fit:cover}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
